// The Reads mark — bold serif "R", exactly matching the app icon.
// No wavy underline, no script font. Clean, classic, high-contrast.
export function ReadsLogo({ size = 36, color = "#0A0A0A", className = "" }) {
  return (
    <span
      className={`inline-flex items-center justify-center ${className}`}
      style={{ height: size, lineHeight: 1, color }}
      data-testid="reads-logo"
      aria-label="Reads"
    >
      <span
        style={{
          // Match the app icon: bold serif R.
          fontFamily: "'Playfair Display', 'DM Serif Display', Georgia, serif",
          fontWeight: 800,
          fontSize: `${Math.round(size * 0.95)}px`,
          lineHeight: 1,
          color,
          letterSpacing: "-0.02em",
        }}
      >
        R
      </span>
    </span>
  );
}
